import type { ProductId } from '../../common/types';
import { ProductKey, type ProductLicenseResponse } from './types';

const SUPPORTED_PRODUCTS = [
	ProductKey.JIRA_SOFTWARE,
	ProductKey.CONFLUENCE,
	ProductKey.LOOM,
	ProductKey.ROVO,
];

const PRODUCT_DISPLAY_NAME: Record<ProductKey, ProductId> = {
	[ProductKey.JIRA_SOFTWARE]: 'jira',
	[ProductKey.CONFLUENCE]: 'confluence',
	[ProductKey.LOOM]: 'loom',
	[ProductKey.ROVO]: 'rovo',
};

export const getActiveProducts = async (cloudId: string): Promise<Array<ProductId>> => {
	const response = await fetch(`/gateway/api/xflow/${cloudId}/license-information`);

	if (!response.ok) {
		throw new Error(
			`Non-OK response when fetching license information: HTTP ${response.status}: ${response.statusText}`,
		);
	}

	const data = (await response.json()) as ProductLicenseResponse;

	return SUPPORTED_PRODUCTS.filter((product) => data.products[product]?.state === 'ACTIVE').map(
		(product) => PRODUCT_DISPLAY_NAME[product],
	);
};
